import { useLazyQuery, useQuery } from '@apollo/client'
import { Transition } from '@headlessui/react'
import { useEffect, useState } from 'react'

import { Spinner } from '../..'
import { GetVezgoLink, GetVezgoServices } from '../queries'
import VezgoIcon from './vezgo.svg'
export interface ServicesProps {
    onClick?: () => void
    show: boolean
}

export function Services({ show }: ServicesProps): JSX.Element {
    const [serviceLoading, setServiceLoading] = useState<null | string>(null)
    const [getLink, { data: linkData, loading: loadingLink }] =
        useLazyQuery(GetVezgoLink)

    const { data, loading } = useQuery(GetVezgoServices)

    const geteConnectionLink = async (service: string) => {
        setServiceLoading(service)
        await getLink({
            variables: {
                provider: service,
            },
        })
    }

    useEffect(() => {
        if (!loadingLink && linkData && linkData.getConnectionLink) {
            window.location.href = linkData.getConnectionLink.link
        }
    }, [linkData, loadingLink])

    return (
        <Transition
            appear={true}
            show={show}
            className='flex flex-col items-center justify-center h-full px-8 py-8 lg:justify-between lg:h-auto'
            style={{ minHeight: 300 }}
            as='div'
            enter='transition ease-in-out duration-300 delay-600 transform opacity-0'
            enterFrom='translate-x-full opacity-0'
            enterTo='translate-x-0 opacity-100'
            leave='transition ease-in-out duration-300 transform opacity-100 absolute'
            leaveFrom='translate-x-0 opacity-100'
            leaveTo='-translate-x-full opacity-0'>
            <p className='text-xl text-center text-white'>
                Select one of this Services
            </p>
            <div className='flex flex-col items-center justify-center text-white'>
                <img
                    alt='vezgo-logo'
                    style={{ width: '120px' }}
                    className='w-1/2 ml-4'
                    src={VezgoIcon}
                />
                <div
                    className='grid w-full grid-cols-4 gap-4 mt-8 overflow-auto scrollbar-thin scrollbar-thumb-whiteOverlay scrollbar-track-whiteOverlay scrollbar-thumb-rounded-full scrollbar-track'
                    style={{ maxHeight: 500 }}>
                    {!loading ? (
                        data?.getVezgoProviders?.map((provider: any) => {
                            return (
                                <div
                                    className='flex flex-col items-center justify-center p-2 rounded-lg hover:bg-whiteOverlay '
                                    onClick={() =>
                                        geteConnectionLink(provider.name)
                                    }>
                                    {serviceLoading === provider.name ? (
                                        <Spinner size={'large'} color='white' />
                                    ) : (
                                        <>
                                            <img
                                                src={provider.logo}
                                                className='w-8'
                                                alt={provider.name}
                                            />
                                            <p className='m-0 text-center text-white'>
                                                {provider.displayName}
                                            </p>
                                        </>
                                    )}
                                </div>
                            )
                        })
                    ) : (
                        <Spinner />
                    )}
                </div>
            </div>
        </Transition>
    )
}
